import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CarSearchInput, {
  CarSearchInputProps,
} from './car-search-input/CarSearchInput';

interface Props {
  initialValue?: string;
}

const VinSearchInput: React.FC<
  React.PropsWithChildren<Props & CarSearchInputProps>
> = ({ initialValue, disabled, ...otherProps }) => {
  const { t } = useTranslation();
  const [vin, setVin] = useState<string | undefined>(initialValue);
  const requiredLength = 17;

  return (
    <CarSearchInput
      value={vin}
      setValue={setVin}
      inputMaxLength={requiredLength}
      inputPattern="\d+"
      validationError={
        vin?.length !== requiredLength &&
        (t('A vin is 17 characters long') as string)
      }
      disabled={disabled || vin?.length !== requiredLength}
      {...otherProps}
    />
  );
};

export default VinSearchInput;
